<template>
  <b-modal
    v-model="showModalInternal"
    id="drugstore-group-form-modal"
    :title="modalTitle"
    title-class="font-18"
    hide-footer
    size="lg"
    @hidden="onModalHidden"
  >
    <div class="p-3">
      <form @submit.prevent="saveGroup">
        <div class="mb-3">
          <label class="form-label fw-bold">Nazwa grupy (wymagana)</label>
          <input
            v-model="group.name"
            type="text"
            class="form-control"
            placeholder="Wprowadź nazwę grupy"
            required
          />
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Opis</label>
          <textarea
            v-model="group.description"
            class="form-control"
            rows="3"
            placeholder="Dodaj opis grupy (opcjonalnie)"
          ></textarea>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Priorytet</label>
          <input
            v-model.number="group.priority"
            type="number"
            class="form-control"
            placeholder="0"
          />
          <small class="text-muted">Wyższy priorytet oznacza ważniejszą grupę.</small>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
          <button
            type="button"
            class="btn btn-outline-secondary px-4"
            @click="closeModal"
          >
            Anuluj
          </button>
          <button
            type="submit"
            class="btn btn-primary px-4"
            :disabled="!group.name"
          >
            <i class="fas fa-save me-1"></i> Zapisz
          </button>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue-next";
import { useCommonAppModule } from "@/state/pinia/commonAppModule";

export default {
  name: "DrugstoreGroupFormModal",
  components: { BModal },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    editGroup: {
      type: Object,
      default: () => null
    }
  },
  emits: ["update:showModal", "onSaved"],
  data() {
    return {
      showModalInternal: false,
      group: this.getEmptyGroup()
    };
  },
  computed: {
    commonModule() {
      return useCommonAppModule();
    },
    modalTitle() {
      return this.group.id ? "Edytuj grupę aptek" : "Dodaj nową grupę aptek";
    }
  },
  methods: {
    getEmptyGroup() {
      return {
        id: null,
        name: "",
        description: "",
        priority: 0
      };
    },
    closeModal() {
      this.showModalInternal = false;
    },
    onModalHidden() {
      this.$emit("update:showModal", false);
    },
    saveGroup() {
      const payload = {
        groupId: this.group.id,
        groupObject: this.group
      };

      let action;
      if (this.group.id) {
        action = this.commonModule.httpUpdateDrugstoreGroup(payload);
      } else {
        action = this.commonModule.httpAddDrugstoreGroup(payload);
      }

      action.then(() => {
        this.$emit("onSaved");
        this.closeModal();
      });
    }
  },
  watch: {
    showModal(newVal) {
      this.showModalInternal = newVal;
      if (newVal) {
        if (this.editGroup) {
          this.group = JSON.parse(JSON.stringify(this.editGroup));
        } else {
          this.group = this.getEmptyGroup();
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
